import {
    get_fornitori,
    create_fornitore,
    update_fornitore,
    duplica_fornitore,
    delete_fornitore,
} from "@/api/api.fornitore.js";

const fornitori = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_fornitori().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_fornitore(id, dati) : create_fornitore(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_fornitore(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                duplica_fornitore(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default fornitori;
